export default "__VITE_ASSET__DbB9VR36__"